export const ObjectiveCommentKind = {
    COMMENT: 'Comment',
    MEASURE_UPDATE: 'MeasureUpdate',
    STRUCTURE_UPDATE: 'StructureUpdate',
} as const;

export type ObjectiveCommentKindValue =
    (typeof ObjectiveCommentKind)[keyof typeof ObjectiveCommentKind];
